import { useState } from 'react';
import { Autocomplete, IconButton } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { FaSearch } from "react-icons/fa";
import Filters from '../../Shared/Filters/Filters';
import { useEffect } from 'react';
import './SearchBar.css';

function SearchBar({ search, applyFilters, searchOptions, filterOptions, autocomplete, disableAutocomplete, dataView }) {
    const [searchValue, setSearchValue] = useState("");
    const [filters, setFilters] = useState([]);

    useEffect(() => {
        if (dataView) {
            setSearchValue("");
            setFilters([]);
        }
    }, [dataView, searchOptions]);

    useEffect(() => {
        search(searchValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        applyFilters(filters);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters]);

    return (
        <Card className='search-card'>
            <CardContent className='search-card-content'>
                {autocomplete ?
                    <Autocomplete
                        disablePortal
                        disabled={disableAutocomplete}
                        options={searchOptions}
                        value={searchValue}
                        onChange={(event) => { setSearchValue(event.target.textContent) }}
                        sx={{ width: '40ch' }}
                        renderInput={(params) => <TextField {...params}
                            label="Search"
                        />}
                    />
                    :
                    <TextField
                        id="searchbar"
                        sx={{ width: '40ch', height: '2rem' }}
                        onChange={(event) => setSearchValue(event.target.value)}
                        slotProps={{
                            input: {
                                endAdornment: <InputAdornment position="end">
                                    <IconButton onClick={() => search(searchValue)}>
                                        <FaSearch />
                                    </IconButton>
                                </InputAdornment>,
                            },
                        }}
                    />
                }
                <Filters options={filterOptions} filters={filters} setFilters={setFilters} />
            </CardContent>
        </Card>
    );
}

export default SearchBar;